export default {
    host : 'https://hooksadmin.masiya.net'
    // host : 'http://mamdev.net'
}